export default __webpack_public_path__ + "static/media/Icon - SCHEDULE Period.31aaec65.svg";